// @flow
import { htoggle, hset } from '../../modules/hash'
import { batch } from '../../modules/lib/batchReducer'
import {
  UI,
  TABS,
  CURRENT_FILTER,
  IS_MAIN_MENU_OPEN,
  IS_USER_MENU_OPEN,
  IS_CURRENT_BIDS_OPEN,
  IS_FILTERS_OPEN,
  SET_TAB_INDEX,
  SET_CURRENT_FILTER,
  TOGGLE_MAIN_MENU,
  TOGGLE_USER_MENU,
  TOGGLE_CURRENT_BIDS,
  TOGGLE_FILTERS
} from './constants'
import type { Action } from '../../core/types'

export const toggleMainMenu = (): Action =>
  batch(
    TOGGLE_MAIN_MENU,
    htoggle(UI, IS_MAIN_MENU_OPEN),
    hset(UI, IS_FILTERS_OPEN, false)
  )

export const toggleUserMenu = (): Action =>
  batch(
    TOGGLE_USER_MENU,
    htoggle(UI, IS_USER_MENU_OPEN),
    hset(UI, IS_FILTERS_OPEN, false)
  )

export const toggleCurrentBids = (): Action =>
  batch(
    TOGGLE_CURRENT_BIDS,
    htoggle(UI, IS_CURRENT_BIDS_OPEN),
    hset(UI, IS_FILTERS_OPEN, false)
  )

export const toggleFilters = (): Action =>
  batch(TOGGLE_FILTERS, htoggle(UI, IS_FILTERS_OPEN))

export const setTabIndex = (tabName: string) => (index: number): Action =>
  batch(SET_TAB_INDEX, hset(UI, `${TABS}.${tabName}`, index))

export const setFilter = (filter: string): Action =>
  batch(SET_CURRENT_FILTER, hset(UI, CURRENT_FILTER, filter))



// WEBPACK FOOTER //
// ./src/services/layout/actions.js